module.exports = __webpack_public_path__ + "static/media/GRTLines.9c23df2b.svg";